import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const duration = 0.4;
const ease = 'power1.in';
const y = 10;
const markers = true;
const start = 'top 75%';

const animationDefault = item =>
    gsap.from(item, {
        y: item.classList.contains('label-button') ? 0 : y,
        opacity: 0,
        ease: ease,
        duration: duration,
        scrollTrigger: {
            trigger: item,
            start: start,
            end: 'top',
            markers: markers,
        },
        onStart: () => {
            console.log('onStart', { item });
        },
        onComplete: () => {
            console.log('onComplete', { item });
        },
    });

const animationWithStagger = ({ item, trigger }) =>
    gsap.from(item, {
        opacity: 0,
        ease: ease,
        duration: duration,
        stagger: 0.15,
        scrollTrigger: {
            trigger: trigger,
            start: start,
            markers: markers,
        },
        onStart: () => {
            console.log('onStart', { item });
        },
        onComplete: () => {
            console.log('onComplete', { item });
        },
    });

const animationWithoutScroll = ({ item }) =>
    gsap.from(item, {
        y: y,
        opacity: 0,
        ease: ease,
        duration: duration,
        onStart: () => {
            console.log('onStart', { item });
        },
        onComplete: () => {
            console.log('onComplete', { item });
        },
    });

const defaultItems = ['.has-animation', '.label-button', '.form-section'];

export const useAnimation = ({ items, container, dependencies = [] }) => {
    console.log('useAnimation', items, container);
    useGSAP(
        () => {
            let targets = gsap.utils.toArray([...defaultItems, ...items]);
            targets.forEach(item => animationDefault(item));
        },
        { dependencies, scope: container, revertOnUpdate: true },
    );
};

export const useAnimationWithStagger = ({ item, container, trigger, dependencies = [] }) => {
    console.log('useAnimationWithStagger');
    useGSAP(
        () => {
            animationWithStagger({ item, trigger });
        },
        { dependencies, scope: container, revertOnUpdate: true },
    );
};

export const useAnimationWithWithoutScroll = ({ item, container, dependencies = [] }) => {
    console.log('useAnimationWithWithoutScroll');
    useGSAP(
        () => {
            animationWithoutScroll({ item });
        },
        { dependencies, scope: container, revertOnUpdate: true },
    );
};
